<template>
  <div class="login-page">
    <div class="login-card">
      <div class="login-icon">💰</div>
      <h2>記帳本登入</h2>
      <p class="login-sub">請輸入您的帳號密碼</p>
      <form @submit.prevent="login" class="login-form">
        <div class="form-group">
          <label for="username">使用者名稱</label>
          <input id="username" v-model="username" type="text" placeholder="輸入使用者名稱" required />
        </div>
        <div class="form-group">
          <label for="password">密碼</label>
          <input id="password" v-model="password" type="password" placeholder="輸入密碼" required />
        </div>
        <div v-if="error" class="login-error">❌ 登入失敗，請檢查帳號密碼</div>
        <button type="submit" class="btn-submit" :disabled="loading">
          <span v-if="!loading">🔐 登入</span>
          <span v-else>登入中...</span>
        </button>
      </form>
    </div>
  </div>
</template>
<script>
import { mapMutations } from 'vuex';
import axios from 'axios'
axios.defaults.baseURL = 'https://mb.kman.idv.tw:9579/';
export default {
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      error: false
    };
  },
  methods: {
    ...mapMutations(["setUser", "setToken"]),
    async login() {
      this.error = false;
      this.loading = true;

      if (localStorage.getItem('setUser') && localStorage.getItem('setToken')) {
        const user = localStorage.getItem("setUser");
        const token = localStorage.getItem("setToken");
        this.$store.commit('setUser', user);
        this.$store.commit('setToken', token);
        this.$router.push('/event');
        this.loading = false;
      } else {
        try {
          const response = await axios.post('login', {
            username: this.username,
            password: this.password
          });
          const user = response.data.user;
          const token = response.data.token;
          this.$store.commit('setUser', user);
          this.$store.commit('setToken', token);
          localStorage.setItem('setUser', user);
          localStorage.setItem('setToken', token);
          this.$router.push('/event');
        } catch (error) {
          this.error = true;
          this.username = "";
          this.password = "";
        } finally {
          this.loading = false;
        }
      }
    }
  },
  mounted() {
    if (localStorage.getItem('setUser') && localStorage.getItem('setToken')) {
      const user = localStorage.getItem("setUser");
      const token = localStorage.getItem("setToken");
      this.$store.commit('setUser', user);
      this.$store.commit('setToken', token);
      this.$router.push('/event');
    }
  }
};
</script>
<style scoped>
.login-page {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
}
.login-card {
  background: var(--card);
  border-radius: var(--radius);
  box-shadow: var(--shadow-md);
  padding: 40px 36px;
  max-width: 400px;
  width: 100%;
  text-align: center;
}
.login-icon { font-size: 48px; margin-bottom: 8px; }
.login-card h2 {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 4px;
}
.login-sub {
  font-size: 14px;
  color: var(--text-light);
  margin-bottom: 24px;
}
.login-form { text-align: left; }
.form-group {
  margin-bottom: 16px;
}
.form-group label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: var(--text-light);
  margin-bottom: 6px;
}
.form-group input {
  width: 100%;
  padding: 10px 14px;
  font-size: 15px;
  border: 1px solid var(--border);
  border-radius: 8px;
  outline: none;
  transition: border-color 0.15s;
}
.form-group input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(79,70,229,0.1);
}
.login-error {
  background: #fef2f2;
  border: 1px solid #fecaca;
  color: #b91c1c;
  padding: 10px 14px;
  border-radius: 8px;
  font-size: 13px;
  margin-bottom: 16px;
}
.btn-submit {
  width: 100%;
  padding: 12px;
  font-size: 15px;
  font-weight: 600;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s;
}
.btn-submit:hover { background: var(--primary-hover); }
.btn-submit:disabled { opacity: 0.6; cursor: not-allowed; }
</style>
